import React from 'react';
import CourseComponent from 'Components/Card/Components/CourseComponent';
import aceUImg from 'assets/images/ace-u.png';
import imagesPath, { getImageSource } from 'utils/imgUtils';

/* TODO: remove */
function AceUniversityCard(props) {
    const { Course: course } = props.data;
    const welcomeMessageTitle = `Welcome to ACE University! Your learning begins here.`

    let img = getImageSource(course.CourseImageUrl) || aceUImg;

    return (
        <CourseComponent course={course} courseImg={img} wrapperModifierClass={course.WrapperModifierClass || "aceU"} welcomeMessageTitle={course.WelcomeMessageTitle || welcomeMessageTitle} />
    )
}

export default AceUniversityCard;
